
import { Injectable, Optional } from '@angular/core';
import {
    HttpClient, HttpHeaders, HttpParams,
    HttpResponse, HttpEvent
} from '@angular/common/http';

import { Observable } from 'rxjs';
import { Configuration } from 'src/applazy/shared/models/configuration';
import { CustomHttpUrlEncodingCodec } from 'src/applazy/shared/models/encoder';
import { environment } from 'src/environments/environment';
import { IPartnersFilteredReadModel } from '../models/partner/partner.model';
import { GeocodeCommand } from '../models/geocodeCommand';

@Injectable({
    providedIn: 'root'
})
export class GeocoderService {

    protected basePath = environment.clientUrl;
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional() configuration: Configuration) {

        if (configuration) {
            this.configuration = configuration;
            this.configuration.basePath = configuration.basePath || this.basePath;

        } else {
            this.configuration.basePath = this.basePath;
        }
    }
    public geocode(apiVersion: string, model: GeocodeCommand, observe?: 'body', reportProgress?: boolean): Observable<IPartnersFilteredReadModel>;
    public geocode(apiVersion: string, model: GeocodeCommand, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<IPartnersFilteredReadModel>>;
    public geocode(apiVersion: string, model: GeocodeCommand, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<IPartnersFilteredReadModel>>;
    public geocode(apiVersion: string, model: GeocodeCommand, observe: any = 'body', reportProgress: boolean = false): Observable<any> {
        let headers = this.defaultHeaders;
        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        const httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.post<any>(`${this.configuration.basePath}/api/v1/geocoder/geocode`,
            model,
            {
                withCredentials: this.configuration.withCredentials,
                params: queryParameters,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }
}
